import { render, staticRenderFns } from "./OpenEnded.vue?vue&type=template&id=6d861635&scoped=true"
import script from "./OpenEnded.vue?vue&type=script&lang=ts"
export * from "./OpenEnded.vue?vue&type=script&lang=ts"
import style0 from "./OpenEnded.vue?vue&type=style&index=0&id=6d861635&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d861635",
  null
  
)

export default component.exports